<template>
<div class="MResume" :class="{hideTabTitle: fromDMApp}">
    <van-tabs sticky v-model="active" animated line-height="2" line-width="28" color="#409EFF" title-inactive-color="#333" title-active-color="#409EFF">
        <van-tab title="我的简历">
            <div v-if="resumeData.fullrate === 100 && !fromDMApp" class="top_tips">
                <p>您的简历完整度{{resumeData.fullrate}}%，快去投递简历吧！</p>
                <p @click="toIndex">前往投递></p>
            </div>
            <div v-else-if="!fromDMApp" class="top_tips">您的简历完整度{{resumeData.fullrate}}%，完善简历投递感兴趣的职位吧！</div>
            <div class="my_resume_warp">
                <div class="resume_baseinfo_box">
                    <div v-if="resumeData.baseinfo.name === ''" class="left_div">
                        <p class="p1">未填写<img @click="toPage('BaseInfo')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_edit.png')" alt=""></p>
                        <p class="p2">工作经验<span>·</span>学历<span>·</span>任职</p>
                    </div>
                    <div v-else class="left_div">
                        <p class="p1">{{resumeData.baseinfo.name}}<img @click="toPage('BaseInfo')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_edit.png')" alt=""></p>
                        <p class="p2">{{resumeData.baseinfo.exptypename}}<span>·</span>{{resumeData.baseinfo.edutypename}}<span>·</span>{{resumeData.baseinfo.jobstatusname}}</p>
                    </div>
                    <img class="user_head_img" :src="resumeData.baseinfo.customericonurl.furl === '' ? require('@/common/images/mtalentimgs/head_img.png') : resumeData.baseinfo.customericonurl.furl" alt="">
                </div>
                <div class="resume_item_box">
                    <div class="title_div">
                        <p class="p_title_text">求职意向</p>
                        <div v-if="resumeData.baseinfo.name" class="handle_img_div"><img @click="toPage('JobIntension')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_edit.png')" alt=""></div>
                    </div>
                    <div v-if="resumeData.baseinfo.wishjobname !== ''" class="Job_Intension_box top20">
                        <div>
                            <span>{{resumeData.baseinfo.wishjobname}}</span>
                            <span v-if="resumeData.baseinfo.wishsalary === 0 && resumeData.baseinfo.wishsalarymax === 0 && resumeData.baseinfo.wishindustry !== ''">面议</span>
                            <span v-if="resumeData.baseinfo.wishsalary !== 0 && resumeData.baseinfo.wishsalarymax !== 0">{{resumeData.baseinfo.wishsalary}}-{{resumeData.baseinfo.wishsalarymax}}万/年</span>
                            <span v-if="resumeData.baseinfo.wishindustry === ''"></span>
                        </div>
                        <div>
                            <span>{{resumeData.baseinfo.wishplace}}</span>
                            <span>{{resumeData.baseinfo.wishindustry}}</span>
                        </div>
                    </div>
                </div>
                <div class="resume_item_box">
                    <div class="title_div">
                        <p class="p_title_text">工作经历</p>
                        <div v-if="resumeData.baseinfo.name" class="handle_img_div"><img @click="toPage('WorkHistory')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_add.png')" alt=""></div>
                    </div>
                    <div v-if="resumeData.conpanyinfolist.length > 0" class="Work_History_box top20">
                        <div class="list_item_box" v-for="(item, index) in resumeData.conpanyinfolist" :key="index" @click="toPage2('WorkHistory', item)">
                            <div class="firm_div">
                                <div class="firm_name van-ellipsis">{{item.companyname}}</div>
                                <div class="time_div">
                                    <span>{{item.jobbegin2}}-{{item.istoday ? '至今' : item.jobend2}}</span>
                                    <img :src="require('@/common/images/mtalentimgs/icon_right.png')" alt="">
                                </div>
                            </div>
                            <div class="common2_text">{{item.jobname}}</div>
                            <div v-if="item.jobinfo !== ''" class="Performance_text common_text van-multi-ellipsis--l2">{{item.jobinfo}}</div>
                        </div>
                    </div>
                </div>
                <div class="resume_item_box">
                    <div class="title_div">
                        <p class="p_title_text">项目经历</p>
                        <div v-if="resumeData.baseinfo.name" class="handle_img_div"><img @click="toPage('ProjectExperience')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_add.png')" alt=""></div>
                    </div>
                    <div v-if="resumeData.projectinfolist.length > 0" class="Project_Experience_box top20">
                        <div class="list_item_box" v-for="(item, index) in resumeData.projectinfolist" :key="index" @click="toPage2('ProjectExperience', item)">
                            <div class="firm_div">
                                <div class="firm_name van-ellipsis">{{item.projectname}}</div>
                                <div class="time_div">
                                    <span>{{item.projectbegin2}}-{{item.istoday ? '至今' : item.projectend2}}</span>
                                    <img :src="require('@/common/images/mtalentimgs/icon_right.png')" alt="">
                                </div>
                            </div>
                            <div class="position_title common2_text">{{item.dutyname}}</div>
                            <div class="common_text van-multi-ellipsis--l2">职责：{{item.projectduty}}</div>
                            <div v-if="item.projectexpinfo !== ''" class="common_text van-multi-ellipsis--l2">业绩：{{item.projectexpinfo}}</div>
                            <div class="common_text van-multi-ellipsis--l2">描述：{{item.projectinfo}}</div>
                        </div>
                    </div>
                </div>
                <div class="resume_item_box">
                    <div class="title_div">
                        <p class="p_title_text">教育经历</p>
                        <div v-if="resumeData.baseinfo.name" class="handle_img_div"><img @click="toPage('EduExperience')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_add.png')" alt=""></div>
                    </div>
                    <div v-if="resumeData.eduinfolist.length > 0" class="Edu_Experience_box top20">
                        <div class="list_item_box" v-for="(item, index) in resumeData.eduinfolist" :key="index" @click="toPage2('EduExperience', item)">
                            <div class="firm_div">
                                <div class="firm_name van-ellipsis">{{item.eduname}}</div>
                                <div class="time_div">
                                    <span>{{item.edubegin2}}-{{item.istoday ? '至今' : item.eduend2}}</span>
                                    <img :src="require('@/common/images/mtalentimgs/icon_right.png')" alt="">
                                </div>
                            </div>
                            <div class="edu_info_div">
                                <div class="common2_text">{{item.edulevelname}}</div>
                                <div class="common2_text">{{item.majorname}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="resume_item_box">
                    <div class="title_div">
                        <p class="p_title_text">自我评价</p>
                        <div v-if="resumeData.baseinfo.name" class="handle_img_div"><img @click="toPage('SelfEvaluation')" class="handle_img" :src="require('@/common/images/talentsimg/aicon_edit.png')" alt=""></div>
                    </div>
                    <div v-if="resumeData.baseinfo.selfevaluation !== ''" class="Self_Evaluation_box top20 van-multi-ellipsis--l3 common_text">{{resumeData.baseinfo.selfevaluation}}</div>
                </div>
            </div>
        </van-tab>
        <van-tab title="应聘记录" v-if="!fromDMApp">
            <div class="apply_record_warp content_warp">
                <pull :pull="pull" :page="page" @getList="getList">
                    <NoData v-if="dataList.length === 0"></NoData>
                    <div class="post_item_box" v-for="(item, index) in dataList" :key="index" @click="jobClick(item)">
                        <div class="job_info_box">
                            <p class="p1">{{item.jobname}}</p>
                            <p v-if="item.status === 1 || item.status === 9 || item.status === 20" class="p2 green_text">已投递</p>
                            <p v-if="item.status === 10" class="p2 yellow_text">投递成功</p>
                            <p v-if="item.status === 11" class="p2 red_text">已谢绝</p>
                        </div>
                        <p class="salary_text">{{item.salarytext}}</p>
                        <p class="p_name_text">{{item.companydisplayname}}</p>
                        <div class="tags_box">
                            <div class="tags_div">
                                <p>{{item.jobplace}}</p>
                                <p>{{item.exptypename}}</p>
                            </div>
                            <p class="time_text">{{item.datetime}}</p>
                        </div>
                    </div>
                 </pull>
            </div>
        </van-tab>
    </van-tabs>
</div>
</template>

<script>
import Pull from 'views/mobile/components/pull/pull'
import NoData from 'views/mobile/components/noData/noData'
import {getResumeAllInfo, getResumeedLiveInfo} from 'api/talentApi'
import {getCustomerInfoByApp} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import { getAssignKeyLocationSearch, setCookie } from 'common/js/tools.js'
export default {
    name: 'MResume',
    data() {
        return {
            resumeData: {
                baseinfo: {
                    customericonurl: {
                        furl: ''
                    }
                },
                conpanyinfolist: [],
                projectinfolist: [],
                eduinfolist: []
            },
            active: 0,
            dataList: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            fromDMApp: false
        }
    },
    mounted() {
        document.title = '我的简历'
        this.setNoDataTip('暂无应聘记录')
        if (getAssignKeyLocationSearch('apptoken') && getAssignKeyLocationSearch('appflag', ['appByDM'])) {
            this.fromDMApp = true
            this.getCustomerInfoByApp()
        } else {
            this.fromDMApp = false
            this.findResumeAllInfo()
            this.getList()
        }
    },
    activated() {},
    methods: {
        getCustomerInfoByApp() {
            this.setLoading(true)
            getCustomerInfoByApp({
                data: {},
                success: data => {
                    let user = {
                        innerid: data.data.innerid ? data.data.innerid : '',
                        isperfect: data.data.isperfect ? data.data.isperfect : '',
                        loginToken: data.data.logintoken ? data.data.logintoken : '',
                        loginname: data.data.loginname ? data.data.loginname : '',
                        logourl: data.data.logourl ? data.data.logourl : '',
                        mobile: data.data.mobile ? data.data.mobile : '',
                        name: data.data.name ? data.data.name : '',
                        nickname: data.data.nickname ? data.data.nickname : '',
                        isLogin: true,
                        zjmemtype: data.data.zjmemtype ? data.data.zjmemtype : 0
                    }
                    this.setUser(user)
                    sessionStorage.setItem('user', JSON.stringify(user))
                    setCookie('token', user.loginToken, 7)
                    this.findResumeAllInfo()
                    // this.getList()
                },
                error: data => {
                    this.setLoading(false)
                    // this.$toast.fail(data.msg)
                }
            })
        },
        findResumeAllInfo() {
            this.setLoading(true)
            var params = {}
            getResumeAllInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.resumeData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        toPage2(val, val2) {
            this.$router.push({name: val, query: {'innerid2': val2.innerid, 'resumeinnerid': val2.resumeinnerid}})
        },
        toPage(val) {
            this.$router.push({name: val, query: {'innerid': this.resumeData.baseinfo.innerid}})
        },
        toIndex() {
            this.$router.push({name: 'MTalentIndex'})
        },
        jobClick(val) {
            if (!this.fromDMApp) {
                this.$router.push({name: 'MJobInfo', query: {'jobid': val.jobinnerid}})
            } else {
                this.$router.push({name: 'MJobInfo', query: {'jobid': val.jobinnerid, appflag: 'appByDM'}})
            }
        },
        getList() {
            this.setLoading(true)
            getResumeedLiveInfo({
                data: Object.assign({}, this.paramsData, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setNoDataTip',
            'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {Pull, NoData}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.MResume {
    font-family:PingFangSC-Medium,PingFang SC;
    &.hideTabTitle {
        .van-tabs {
            .van-sticky {
                display: none;
            }
        }
    }
    .van-tabs__nav--line {
        padding-bottom: 0.16rem;
    }
    .content_warp {
        min-height: calc(100vh - 1.08rem);
        margin-top: 0.2rem;
    }
    .top_tips {
        padding: 0 0.32rem;
        background-color: #FEFCEB;
        line-height: 0.72rem;
        font-size: 0.24rem;
        color: #F96A0E;
        display: flex;
        justify-content: space-between;
        &>p:nth-of-type(2) {
            color: #409EFF;
        }
    }
    .my_resume_warp {
        min-height: calc(100vh - 1.6rem);
        background-color: #FFF;
        padding: 0 0.32rem;
        color: #333;
        .resume_baseinfo_box {
            border-bottom: 0.01rem solid #E5E5E5;
            padding: 0.4rem 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left_div {
                .p1 {
                    display: flex;
                    align-items: center;
                    color: #000;
                    font-weight: bold;
                    font-size: 0.52rem;
                    line-height: 0.74rem;
                    margin-bottom: 0.1rem;
                    &>img {
                        width: 0.32rem;
                        height: 0.32rem;
                        margin-left: 0.3rem;
                    }
                }
                .p2 {
                    line-height: 0.34rem;
                    font-size: 0.24rem;
                    color: #666;
                    &>span {
                        margin: 0 0.2rem;
                    }
                }
            }
            .user_head_img {
                width: 1.2rem;
                height: 1.2rem;
                border-radius: 0.6rem;
            }
        }
        .resume_item_box {
            border-bottom: 0.01rem solid #E5E5E5;
            padding: 0.4rem 0;
            .title_div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .p_title_text {
                    font-weight: bold;
                    font-size: 0.32rem;
                    line-height: 0.46rem;
                }
                .handle_img_div {
                    .handle_img {
                        width: 0.32rem;
                        height: 0.32rem;
                    }
                }
            }
            .top20 {
                margin-top: 0.4rem;
            }
            .Job_Intension_box {
                &>div {
                    span {
                        font-size: 0.28rem;
                        line-height: 0.4rem;
                        color: #999;
                    }
                    span + span {
                        margin-left: 0.2rem;
                    }
                }
                &>div:nth-of-type(1) {
                    span {
                        font-weight: bold;
                        color: #333;
                    }
                }
                div + div {
                    margin-top: 0.1rem;
                }
            }
            .Work_History_box {
                .Performance_text {
                    margin-top: 0.24rem;
                }
            }
            .Project_Experience_box {
                .position_title {
                    margin-bottom: 0.24rem;
                }
            }
            .Edu_Experience_box {
                .edu_info_div {
                    display: flex;
                    .common2_text + .common2_text {
                        margin-left: 0.2rem;
                    }
                }
            }
            .Self_Evaluation_box {
                color: #666;
            }
            .list_item_box {
                .firm_div {
                    display: flex;
                    justify-content: space-between;
                    .firm_name {
                        width: 3.92rem;
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        font-weight: bold;
                        color: #333;
                    }
                    .time_div {
                        display: flex;
                        align-items: center;
                        span {
                            line-height: 0.4rem;
                            font-size: 0.28rem;
                            color: #999;
                        }
                        img {
                            width: 0.15rem;
                            height: 0.25rem;
                            margin-left: 0.2rem;
                        }
                    }
                }
            }
            .list_item_box + .list_item_box {
                margin-top: 0.4rem;
            }
            .common_text {
                color: #666;
                font-size: 0.28rem;
                line-height: 0.4rem;
                text-align: justify;
            }
            .common_text + .common_text {
                margin-top: 0.1rem;
            }
            .common2_text {
                color: #999;
                font-size: 0.28rem;
                line-height: 0.4rem;
                margin-top: 0.1rem;
            }
        }
    }
    .apply_record_warp {
        .van-pull-refresh {
            min-height: 70vh;
        }
        .van-list__finished-text {
            font-size: 0.24rem;
        }
        .post_item_box {
            background-color: #fff;
            padding: 0.32rem;
            margin-top: 0.2rem;
            .job_info_box {
                height: 0.44rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .p1 {
                    width: 4.86rem;
                    font-weight: bold;
                    font-size:0.32rem;
                    width: 4rem;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                .p2 {
                    font-size: 0.28rem;
                }
                .green_text {
                    color: #67C23A;
                }
                .yellow_text {
                    color: #FF7F04;
                }
                .red_text {
                    color: #F56C6C;
                }
            }
            .salary_text {
                color: #FF7F04;
                font-size: 0.32rem;
                margin: 0.08rem 0;
                line-height: 0.46rem;
                font-weight: bold;
            }
            .p_name_text {
                line-height: 0.4rem;
                font-size: 0.28rem;
                margin-bottom: 0.2rem;
                color: #999999;
            }
            .tags_box {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .tags_div {
                    display: flex;
                    &>p {
                        color: #5EBDFF;
                        border-radius: 0.04rem;
                        padding: 0 0.1rem;
                        height: 0.4rem;
                        line-height: 0.4rem;
                        text-align: center;
                        font-size: 0.24rem;
                        border: 0.02rem solid #5EBDFF;
                        max-width: 1.3rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    p + p {
                        margin-left: 0.2rem;
                    }
                }
                .time_text {
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    color: #999999;
                }
            }
        }
    }
    .noData{
        height: calc(100vh - 1.08rem);
        background: #FFF;
    }
}
</style>